import { useNavigate } from 'react-router-dom';
import { categories } from '@/mocks/data';

export default function CategoryGrid() {
  const navigate = useNavigate();

  const handleClick = (slug: string) => {
    navigate(`/category/${slug}`);
    window.scrollTo({ top: 0, behavior: 'smooth' });
  };

  return (
    <section className="py-14 md:py-20 bg-background-50">
      <div className="w-full px-4 md:px-6 max-w-6xl mx-auto">
        <div className="text-center mb-12">
          <h2 className="font-heading text-2xl md:text-3xl font-bold text-foreground-900 mb-3">
            探索内容分类
          </h2>
          <p className="text-foreground-600 max-w-lg mx-auto text-sm md:text-base">
            六大主题板块，从作品解析到创作指南，全方位满足你的阅读与学习需求
          </p>
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-4 md:gap-5">
          {categories.map((cat) => (
            <button
              key={cat.id}
              onClick={() => handleClick(cat.slug)}
              className="group text-left p-5 md:p-6 rounded-lg bg-background-100 border border-background-200/70 hover:border-primary-300 transition-all duration-300 cursor-pointer"
            >
              <div className="w-11 h-11 md:w-12 md:h-12 flex items-center justify-center rounded-lg bg-primary-100 text-primary-600 mb-4 group-hover:bg-primary-500 group-hover:text-white transition-colors duration-300">
                <i className={`${cat.icon} text-xl`}></i>
              </div>
              <h3 className="font-heading text-base md:text-lg font-semibold text-foreground-900 mb-2 group-hover:text-primary-600 transition-colors duration-200">
                {cat.name}
              </h3>
              <p className="text-xs md:text-sm text-foreground-600 leading-relaxed mb-3">
                {cat.description}
              </p>
              <div className="flex items-center gap-2 text-xs text-accent-600">
                <span>{cat.count} 篇文章</span>
                <div className="w-4 h-4 flex items-center justify-center group-hover:translate-x-1 transition-transform duration-200">
                  <i className="ri-arrow-right-line"></i>
                </div>
              </div>
            </button>
          ))}
        </div>
      </div>
    </section>
  );
}